//@ts-nocheck
import { useCardName } from "@usher/pe-client-front-end-lib"
import { useSetCardNameMutation } from "@/gql/types"
import { FormProvider } from "react-hook-form"
import { Button } from "@/components/Button"
import { Input } from "@/components/Form/Input"
import { Modal } from "@/components/Modal"
import { useState } from "react"
import { FormattedMessage, useIntl } from "react-intl"

export const CardActionName = () => {
  const [showModal, setShowModal] = useState(false)
  const { name, loading, onSubmit, formMethods, isClosed } = useCardName({
    mutation: useSetCardNameMutation,
    onSuccess: () => setShowModal(false),
  })

  const { $t: t } = useIntl()
  if (isClosed) return <>{name}</>
  return (
    <div className="flex items-center gap-2">
      {name}
      <div className="btn-change" onClick={() => setShowModal(true)} />
      <Modal title="Change card name" onClose={() => setShowModal(false)} show={showModal}>
        <FormProvider {...formMethods}>
          <form onSubmit={formMethods.handleSubmit(onSubmit)}>
            <Input.Form control={formMethods.control} name="name" placeholder={t({ id: "card-name" })} className="my-3" required />
            <Button type="submit" disabled={loading} className="mt-2">
              <FormattedMessage id="pa_195" />
            </Button>
          </form>
        </FormProvider>
      </Modal>
    </div>
  )
}
